goog.provide('el8.ptdata.medOrderFills');
goog.provide('el8.ptdata.model.medOrderFill');

goog.require('el8.model.base');
goog.require('el8.data.pharmacies');
goog.require('el8.model.identify');
goog.require('el8.template.ptdata.medOrderFills');


el8.ptdata.medOrderFills = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDeleteable();

    _class.addBoolean("rxDownload");
    _class.addIntProperty("medOrderId");
    _class.addIntProperty("threadId");

    _class.addBoolean("allowSubstitutions", false, null);
    _class.addStringProperty('medicationDescription');
    _class.addProperty("medication");
    _class.addStringProperty("quantity", true);
    _class.addStringProperty("quantityUnit", true);
    _class.addStringProperty("quantityNote", true);
    _class.addStringProperty("daysSupply", true);
    _class.addStringProperty("directions", true);
    _class.addStringProperty("note", true);
    _class.addStringProperty("substitutions", true);
    _class.addDateTime("lastFillDate");
    _class.addDateTime("writtenDate");
    _class.addStringProperty("prescriber");
    _class.addStringProperty("pharmacyNcpdpid");
    _class.addStringProperty("fuzziness");
    _class.addStringProperty("priorAuth");

    //_class.addBoolean('alert');
    //_class.addBoolean('new');
    
    _class.prototype.getDisplayQuantity = function() {
        return el8.template.ptdata.medOrderFills.displayQuantity({
            quantity: this.getQuantity(),
            quantityUnit: this.getQuantityUnit()
        }).el8_unescape();
    };
    
    _class.prototype.getPharmacy = function() {
        if (this.getPharmacyNcpdpid()) {
            return el8.data.pharmacies.getByKey(this.getPharmacyNcpdpid());
        }
        return null;
    };

    _class.prototype.hasFuzziness = function() {
        return this.getFuzziness() && (this.getFuzziness().indexOf('num_fills') === -1);
    };

    _class.prototype.asSoyMap = function() {
        var m = this.parent.asSoyMap.call(this);
        m['isAlert'] = false; // TODO
        m['quantity'] = this.getDisplayQuantity();
        m['pharmacyName'] = this.getPharmacy() ? this.getPharmacy().getStoreName() : '';
        m['fuzziness'] = this.hasFuzziness();
        m['isDeleted'] = this.isDeleted();
        return m;
    };

    el8.ptdata.model.medOrderFill = function(spec) { return new _class(spec); };

    var that = new el8_EntitySet({
        model: el8.ptdata.model.medOrderFill,
        items: [],
        observable: true,
        defaultFetch: false,
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            el8.appservice.notifier.notify('Fill being deleted...');
            $.el8_ajax({
                type: "DELETE", 
                url: el8.service.urls.get('medOrderFills', [item.getId()]),
                async: (opts.async !== false), // defaults to true
                success: function(data) {
                    if (successCb) { successCb(); }
                    el8.appservice.notifier.notify('Fill deleted.');
                },
                error: errorCb
            });
        }
    });

    that.orderHasUnsignedFills = function(orderId) {
        if (el8.model.idToModelClass(orderId) === 'MedOrder') {
            var fills = that.all();
            for (var i=0; i<fills.length; i++) {
                if (fills[i].isRxDownload() && (fills[i].getMedOrderId() === orderId)) {
                    return true;
                }
            }
        }
        return false;
    };

    that.threadHasUnsignedFills = function(threadId) {
        if (el8.model.idToModelClass(threadId) === 'MedOrderThread') {
            var fills = that.all();
            for (var i=0; i<fills.length; i++) {
                if (fills[i].isRxDownload() && (fills[i].getThreadId() === threadId)) {
                    return true;
                }
            }
        }
        return false;
    };

    that.removeUnsignedByThreadId = function(threadId) {
        var fills = that.all();
        for (var i=0; i<fills.length; i++) {
            if (fills[i].isRxDownload() && (fills[i].getThreadId() === threadId)) {
                that.remove(fills[i], true); // no trigger
            }
        }
    };

    return that;

})();

